import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/_services/toaster.service';
import { ProgramsService } from 'src/app/_services/generatedServices';
import { ImpairmentCategory, ImpairmentCategoryProgramViewModelRead, ImpairmentCategoryUpdateViewModel, TwoDimensionalRunningCategory, ProgramAssignmentViewModel, WalkingCategory, TwoDimensionalRunningCategoryUpdateViewModel, WalkingCategoryProgramViewModelRead, WalkingCategoryUpdateViewModel, TwoDimensionalRunningCategoryProgramViewModelRead } from 'src/app/_models/generatedModels';
import { Enums } from 'src/app/_models/generatedEnums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { dateAsUTCNoTime } from 'src/app/_helpers/extensions.module';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'running-category-change-dialog',
  templateUrl: 'running-category-change-dialog.component.html',
})
export class RunningCategoryChangeDialogComponent implements OnInit {
  initialized = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;
  programs: ImpairmentCategoryProgramViewModelRead[];
  walkingPrograms: WalkingCategoryProgramViewModelRead[];
  impairmentCategoryEnum = Enums.ImpairmentCategoryEnum;
  impairmentCategory = ImpairmentCategory;
  walkingCategoryEnum = Enums.WalkingCategoryEnum;
  walkingCategory = WalkingCategory;
  selectedProgramName: string;
  selectedWalkingProgramName: string;

  twoDimensionAiAssessmentEnabled: boolean;
  twoDimensionalPrograms: TwoDimensionalRunningCategoryProgramViewModelRead[];
  selectedTwoDimensionalRunningProgramName: string;
  twoDimensionalRunningCategory = TwoDimensionalRunningCategory;

  @Input()
  clientUserId: number;

  @Input()
  clientFullName: string;

  @Output()
  saved = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private toastr: ToasterService, private programsService: ProgramsService, public activeModal: NgbActiveModal, private auth: AuthenticationService) {}

  ngOnInit(): void
  {
    this.auth.fetchUserProfile().subscribe(user =>
    {
      this.twoDimensionAiAssessmentEnabled = user.organizationTwoDimensionAiAssessmentEnabled;
    });

    forkJoin([this.programsService.getImpairmentCategoryPrograms(), this.programsService.getWalkingCategoryPrograms(), this.programsService.getTwoDimensionalRunningCategoryPrograms()])
      .subscribe((results) =>
      {
        this.programs = results[0];
        this.walkingPrograms = results[1];
        this.twoDimensionalPrograms = results[2];
        this.setupForm();
      });
  }

  setupForm() {
    this.formGroup = this.fb.group({
      clientUserId: [this.clientUserId],
      impairmentCategory: ['N/A'],
      impairmentCategoryProgramId: [null],
      impairmentCategoryProgramStartDate: [null],
      rtrNotes: [null],
      walkingCategory: ['N/A'],
      walkingCategoryProgramId: [null],
      walkingCategoryProgramStartDate: [null],
      walkingRtrNotes: [null],
      isImpairmentCategoryProgramSet: [null],
      isWalkingCategoryProgramSet: [null],

      isTwoDimensionalRunningCategoryProgramSet: [null],
      twoDimensionalRunningCategory: ['N/A'],
      twoDimensionalRunningCategoryProgramId: [null],
      twoDimensionalRunningCategoryProgramStartDate: [null],

      programId: [null],
      startDate: [null]
    });

    this.initialized = true;
  }

  onCategoryChange(selectedValue: string)
  {
    if (selectedValue == 'N/A'){
      this.formGroup.get('isImpairmentCategoryProgramSet').setValue(false);
      this.formGroup.get('impairmentCategory').clearValidators();
      this.formGroup.get('impairmentCategoryProgramId').clearValidators();
      this.formGroup.get('impairmentCategoryProgramStartDate').clearValidators();
      this.formGroup.get('impairmentCategoryProgramId').setValue(null);
      this.formGroup.get('impairmentCategoryProgramStartDate').setValue(null);
      this.selectedProgramName = null;

      this.formGroup.get('impairmentCategoryProgramId').updateValueAndValidity();
      this.formGroup.get('impairmentCategoryProgramStartDate').updateValueAndValidity();

      return;
    }

    const selectedProgram = this.programs.find(x => x.impairmentCategory == this.impairmentCategory[selectedValue]).program;
    this.selectedProgramName = selectedProgram.name;
    this.formGroup.get('impairmentCategoryProgramId').setValue(selectedProgram.id);

    if (selectedValue) {
      this.formGroup.get('isImpairmentCategoryProgramSet').setValue(true);
      this.formGroup.get('impairmentCategory').setValidators([Validators.required]);
      this.formGroup.get('impairmentCategoryProgramId').setValidators([Validators.required]);
      this.formGroup.get('impairmentCategoryProgramStartDate').setValidators([Validators.required]);
    } else {
      this.formGroup.get('isImpairmentCategoryProgramSet').setValue(false);
    }

    this.formGroup.get('impairmentCategoryProgramId').updateValueAndValidity();
    this.formGroup.get('impairmentCategoryProgramStartDate').updateValueAndValidity();
  }

  onWalkingCategoryChange(selectedValue: string)
  {
    if (selectedValue == 'N/A') {
      this.formGroup.get('isWalkingCategoryProgramSet').setValue(false);
      this.formGroup.get('walkingCategory').clearValidators();
      this.formGroup.get('walkingCategoryProgramId').clearValidators();
      this.formGroup.get('walkingCategoryProgramStartDate').clearValidators();
      this.formGroup.get('walkingCategoryProgramId').setValue(null);
      this.formGroup.get('walkingCategoryProgramStartDate').setValue(null);
      this.selectedWalkingProgramName = null;

      this.formGroup.get('walkingCategoryProgramId').updateValueAndValidity();
      this.formGroup.get('walkingCategoryProgramStartDate').updateValueAndValidity();

      return;
    }

    const selectedProgram = this.walkingPrograms.find(x => x.walkingCategory == this.walkingCategory[selectedValue]).program;
    this.selectedWalkingProgramName = selectedProgram.name;
    this.formGroup.get('walkingCategoryProgramId').setValue(selectedProgram.id);

    if (selectedValue) {
      this.formGroup.get('isWalkingCategoryProgramSet').setValue(true);
      this.formGroup.get('walkingCategory').setValidators([Validators.required]);
      this.formGroup.get('walkingCategoryProgramId').setValidators([Validators.required]);
      this.formGroup.get('walkingCategoryProgramStartDate').setValidators([Validators.required]);
    } else {
      this.formGroup.get('isWalkingCategoryProgramSet').setValue(false);
    }

    this.formGroup.get('walkingCategoryProgramId').updateValueAndValidity();
    this.formGroup.get('walkingCategoryProgramStartDate').updateValueAndValidity();
  }

  onTwoDimensionalRunningCategoryChange(selectedValue: string)
  {
    if (selectedValue == 'N/A') {
      this.formGroup.get('isTwoDimensionalRunningCategoryProgramSet').setValue(false);
      this.formGroup.get('twoDimensionalRunningCategory').clearValidators();
      this.formGroup.get('twoDimensionalRunningCategoryProgramId').clearValidators();
      this.formGroup.get('twoDimensionalRunningCategoryProgramStartDate').clearValidators();
      this.formGroup.get('twoDimensionalRunningCategoryProgramId').setValue(null);
      this.formGroup.get('twoDimensionalRunningCategoryProgramStartDate').setValue(null);
      this.selectedTwoDimensionalRunningProgramName = null;

      this.formGroup.get('twoDimensionalRunningCategoryProgramId').updateValueAndValidity();
      this.formGroup.get('twoDimensionalRunningCategoryProgramStartDate').updateValueAndValidity();

      return;
    }

    const selectedProgram = this.twoDimensionalPrograms.find(x => x.twoDimensionalRunningCategory == this.twoDimensionalRunningCategory[selectedValue]).program;
    this.selectedTwoDimensionalRunningProgramName = selectedProgram.name;
    this.formGroup.get('twoDimensionalRunningCategoryProgramId').setValue(selectedProgram.id);

    if (selectedValue) {
      this.formGroup.get('isTwoDimensionalRunningCategoryProgramSet').setValue(true);
      this.formGroup.get('twoDimensionalRunningCategory').setValidators([Validators.required]);
      this.formGroup.get('twoDimensionalRunningCategoryProgramId').setValidators([Validators.required]);
      this.formGroup.get('twoDimensionalRunningCategoryProgramStartDate').setValidators([Validators.required]);
    } else {
      this.formGroup.get('isTwoDimensionalRunningCategoryProgramSet').setValue(false);
    }

    this.formGroup.get('twoDimensionalRunningCategoryProgramId').updateValueAndValidity();
    this.formGroup.get('twoDimensionalRunningCategoryProgramStartDate').updateValueAndValidity();
  }

  onOptionalProgramChange()
  {
    if (this.formGroup.get('programId').value) {
      this.formGroup.get('startDate').setValidators([Validators.required]);
    } else {
      this.formGroup.get('startDate').setValidators([]);
    }

    this.formGroup.get('startDate').updateValueAndValidity();
  }

  onOptionalProgramDateChange()
  {
    if (this.formGroup.get('startDate').value) {
      this.formGroup.get('programId').setValidators([Validators.required]);
    } else {
      this.formGroup.get('programId').setValidators([]);
    }

    this.formGroup.get('programId').updateValueAndValidity();
  }
  
  onSave()
  {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) =>
    {
      const formData: ImpairmentCategoryUpdateViewModel = Object.assign({}, this.formGroup.getRawValue());
      const gcFormData: WalkingCategoryUpdateViewModel = Object.assign({}, this.formGroup.getRawValue());
      const optionalProgramFormData: ProgramAssignmentViewModel = Object.assign({}, this.formGroup.getRawValue());
      const twoDimensionalFormData: TwoDimensionalRunningCategoryUpdateViewModel = Object.assign({}, this.formGroup.getRawValue());

      let assignentResult: Observable<any>[] = [];

      if (formData.impairmentCategoryProgramId) {
        formData.impairmentCategoryProgramStartDate = dateAsUTCNoTime(formData.impairmentCategoryProgramStartDate);
        assignentResult.push(this.programsService.assignCurrentImpairmentCategoryProgramToClient(formData));
      }

      if (gcFormData.walkingCategoryProgramStartDate) {
        gcFormData.walkingCategoryProgramStartDate = dateAsUTCNoTime(gcFormData.walkingCategoryProgramStartDate);
        assignentResult.push(this.programsService.assignCurrentWalkingCategoryProgramToClient(gcFormData));
      }

      if (twoDimensionalFormData.twoDimensionalRunningCategoryProgramStartDate) {
        twoDimensionalFormData.twoDimensionalRunningCategoryProgramStartDate = dateAsUTCNoTime(twoDimensionalFormData.twoDimensionalRunningCategoryProgramStartDate);
        assignentResult.push(this.programsService.assignCurrentTwoDimensionalRunningCategoryProgramToClient(twoDimensionalFormData));
      }

      if (optionalProgramFormData.startDate) {
        optionalProgramFormData.startDate = dateAsUTCNoTime(optionalProgramFormData.startDate);
        assignentResult.push(this.programsService.assignProgramToClient(optionalProgramFormData));
      }

      forkJoin(assignentResult)
        .subscribe((results) =>
        {
          this.toastr.success('Program Assigned', 'Success');
          this.saved.emit(true);
          this.activeModal.dismiss('saved');
        });

      if (assignentResult.length == 0) {
        this.activeModal.dismiss('saved');
      }
    });
  }
}
